import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { PrimaryButton } from '@components/Buttons/PrimaryButton';
import { SecondaryButton } from '@components/Buttons/SecondaryButton';
import { IForm } from '@hooks/useForm';
import { IStepper } from '@hooks/useStepper';
import { useValidation } from '@hooks/useValidation';
import { Box, makeStyles } from '@material-ui/core';
import { IContratoCliente } from '@model/ContratoCliente';
import { useThemeColor } from '@themes/Colors';
import { yup } from '@validations/Yup';
import clsx from 'clsx';
import React from 'react';

export type ContratoCommandProps = {
    stepper: IStepper
    form: IForm<Partial<IContratoCliente>>
    onPrev?: VoidFunction
    onNext?: VoidFunction
    onCancel?: VoidFunction
}

export function ContratoCommand ({stepper, form, onPrev, onNext, onCancel}: ContratoCommandProps) {
    const cls = useStyles();
    const themeColor = useThemeColor();

    const handleCancel = React.useCallback(() => {
        form.reset();

        if (onCancel !== undefined) {
            onCancel();
        }

    }, [form, onCancel]);

    const validation = useValidation<IContratoCliente>({
        inicio: yup.date().required(),
        valorPlano: yup.number().positive(),
        valorAssessoria: yup.number().positive(),
        franquiaGb: yup.number().positive(),
        valorChip: yup.number().min(0),
        cobrarInteira: yup.string().required()
    });

    const handlePrev = React.useCallback(() => {
        form.saveValues();
        stepper.prev();
        if (onPrev !== undefined) {
            onPrev();
        }
    }, [form, onPrev, stepper]);

    const next = React.useCallback(() => {
        form.saveValues();
        stepper.next();

        if (onNext !== undefined) {
            onNext();
        }
    }, [form, onNext, stepper]);

    const handleNext = React.useCallback(() => {
        const values = form.getInputValues();

        form.clearErrors();
        validation.validate(values)
            .then(() => {
                next();
            })
            .catch(form.setErrorsFromYup);
    }, [form, next, validation]);

    return (
        <Box className={cls.box}>
            <HorizontalGrid className={clsx(themeColor.component.commandPanel, cls.grid)}>
                <GridItem>
                    <PrimaryButton onClick={handlePrev}>Voltar</PrimaryButton>
                </GridItem>

                <GridItem floatRight>
                    <HorizontalGrid spacing={1} verticalAlign="center">
                        <React.Fragment>
                            <GridItem>
                                <SecondaryButton onClick={handleCancel}>Cancelar</SecondaryButton>
                            </GridItem>

                            <GridItem>
                                <PrimaryButton onClick={handleNext}>Avançar</PrimaryButton>
                            </GridItem>
                        </React.Fragment>
                    </HorizontalGrid>
                </GridItem>
            </HorizontalGrid>
        </Box>
    )
}

const useStyles = makeStyles(theme => ({
    box: {
        marginTop: theme.spacing(2)
    },

    grid: {
        padding: `${theme.spacing(1)}px ${theme.spacing(4)}px`
    }
}));